import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {fetchSelectedCustomerGoogleAdsData} from './GoogelAdsAPI'
const initialState = {
  status: "idle",
  error: null,
  data: {},
  googleProfileInfo: {},
  accessToken: null,
  adsAccountStatus: "idle",
  adsAccountData: null,
  selectedAdsAccountId: null,
  selectedAd: null,
  selectedAdData: null,
  customers_id : []
};

export const viewGoogleAdsData = createAsyncThunk(
  "facebook/adsAccounts",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_age";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_age";
     try {
      
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data", response);
      return {customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWithGender = createAsyncThunk(
  "googleAds/adsAccountsWithGender",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_gender";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_gender";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with gender", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWithKeyword = createAsyncThunk(
  "googleAds/adsAccountsWithKeyword",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_keyword";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_keyword";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with keyword", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWithLocation = createAsyncThunk(
  "googleAds/adsAccountsWithLocation",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_location";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_location";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with location", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWithCampaign = createAsyncThunk(
  "googleAds/adsAccountsWithCampaign",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_campaign";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_campaign";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with location", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWitSearchTerms = createAsyncThunk(
  "googleAds/adsAccountsWithSearchTerms",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_searchterms";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_campaign";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with location", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const viewGoogleAdsDataWithLandingPage = createAsyncThunk(
  "googleAds/adsAccountsWithLandingPage",
  async (data, { rejectWithValue }) => {
    let { customer_id, access_token } = data;
    const googleAds_baseURL = "https://ads.causalfunnels.com:5002/get_ads_data_with_landingpage";
    // const googleAds_baseURL = "http://127.0.0.1:5002/get_ads_data_with_campaign";
    try {
      const response = await fetchSelectedCustomerGoogleAdsData(googleAds_baseURL, access_token, customer_id);
      console.log("ads account data with location", response);
      return { customer_id, data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const googleAdsSlice = createSlice({
  name: "googleAds",
  initialState,
  reducers: {
      setGoogleAdsLoggedInUserInfo: (state, action) => {
      const result = action.payload;
      state.data = result;
      try {
        state.googleProfileInfo["name"] = result?.name || "";
        state.googleProfileInfo["profile_pic"] = result?.picture || "";
        state.accessToken = result?.access_token;
      } catch (error) {
        console.log("error occurred during setting fb profile data", error);
      }
    },
    setGoogleAdCustomersId: (state, action) => {
      state.customers_id = action.payload
    },
    resetSelectedAd: (state, action) => {
      state.selectedAd = null;
      state.selectedAdData = null;
    },
    updateadsAccountData: (state, action) => {
      state.adsAccountData = action.payload
    },
    resetgoogleAdsData: (state, action) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewGoogleAdsData.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsData.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload
        console.log("---customer_id, data---", customer_id, data)
        state.selectedAdsAccountId = customer_id;
        state.adsAccountData = data;
      })
      .addCase(viewGoogleAdsData.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWithGender.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWithGender.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (gender)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountDatawithGender = data;
      })
      .addCase(viewGoogleAdsDataWithGender.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWithKeyword.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWithKeyword.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (gender)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountDatawithKeyword = data;
      })
      .addCase(viewGoogleAdsDataWithKeyword.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWithLocation.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWithLocation.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (location)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountDatawithLocation = data;
      })
      .addCase(viewGoogleAdsDataWithLocation.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWithCampaign.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWithCampaign.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (campaign)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountswithCampaign = data;
      })
      .addCase(viewGoogleAdsDataWithCampaign.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWitSearchTerms.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWitSearchTerms.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (campaign)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountsWithSearchTerms = data;
      })
      .addCase(viewGoogleAdsDataWitSearchTerms.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(viewGoogleAdsDataWithLandingPage.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(viewGoogleAdsDataWithLandingPage.fulfilled, (state, action) => {
        state.adsAccountStatus = "idle";
        let { customer_id, data } = action.payload;
        console.log("---customer_id, data (Landing page)---", customer_id, data);
        state.selectedAdsAccountId = customer_id;
        state.adsAccountsWithLandingPage = data;
      })
      .addCase(viewGoogleAdsDataWithLandingPage.rejected, (state, action) => {
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      });
  }
});

export const { setGoogleAdsLoggedInUserInfo, setGoogleAdCustomersId} = googleAdsSlice.actions;

export const SelectGoogleProfileData = (state) => state.google_ads.googleProfileInfo;
export const SelectGoogleAccessToken = (state) => state.google_ads.accessToken;
export const SelectGoogleAdsAccountData = (state) => state.google_ads.adsAccountData;
export const SelectGoogleAdsAccountDatawithGender = (state) => state.google_ads.adsAccountDatawithGender;
export const SelectGoogleAdsAccountDatawithkeyword = (state) => state.google_ads.adsAccountDatawithKeyword;
export const SelectGoogleAdsAccountDatawithlocation = (state) => state.google_ads.adsAccountDatawithLocation;
export const SelectGoogleAdsAccountDatawithcampaign = (state) => state.google_ads.adsAccountswithCampaign;
export const SelectGoogleAdsAccountDatawithsearchterms = (state) => state.google_ads.adsAccountsWithSearchTerms;
export const SelectGoogleAdsAccountDatawithlandingpage = (state) => state.google_ads.adsAccountsWithLandingPage;

export const SelectGoogleAdsActiveAccount = (state) => state.google_ads.selectedAdsAccountId
export const selectedGoogleAdData = (state) => state.google_ads.selectedAdData
export const selectedGoogleAdCustomersId = (state) => state.google_ads.customers_id


function getAdsAccounts(adsdata) {
  let result = adsdata?.map(({ name, id }) => ({ name, id }));
  return result;
}

export default googleAdsSlice.reducer;